import { useTheme } from "@up/data";
import { Toast, ToastTitle } from "@up/ui";

const reload = function () {
  window.location.reload();
};

export function UserDataLoadError() {
  const theme = useTheme();

  return (
    <div>
      <Toast variant="error">
        <ToastTitle variant="error">This is embarrassing</ToastTitle>
        We&apos;re having trouble loading your application. You can try again or{" "}
        <a className="underline" href={`mailto:${theme.supportEmail}`}>
          email support
        </a>
        .
      </Toast>

      <br />

      <button className={theme.buttonPrimaryClass} onClick={reload}>
        Try Again
      </button>
    </div>
  );
}
